export const DEFAULT_ACTION = 'app/CollectionList/DEFAULT_ACTION';
export const FETCH_SETTLEMENT_BANK = 'app/CollectionList/FETCH_SETTLEMENT_BANK';
export const SET_SETTLEMENT_BANK = 'app/CollectionList/SET_SETTLEMENT_BANK';
export const SETTLEMENT_BANK_ERROR = 'app/CollectionList/SETTLEMENT_BANK_ERROR';
export const RESET_SETTLEMENT_BANK = 'app/CollectionList/RESET_SETTLEMENT_BANK';
